export default {
  name: 'Loader',
  props: {
    loaderClass: {
      type: String,
      default: 'col-12 d-flex align-items-center h-100 p-5 justify-content-center'
    }
  }
};